
import Draggable from 'react-draggable';
import CloseIcon from '@mui/icons-material/Close';
import './Popup.scss';
import { Grid } from 'src/shared/grid';
import { StationMetaDataPopUp } from './stations/StationMetaDataPopUp';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ChartPopUpWXNfdrs } from './chartsPopUp';
import { Button, IconButton, MenuItem, Select } from '@mui/material';
import { useStoreContext } from 'src/store/context';
import { useChartTableSelect } from '../../../store/actions';
import { TablePopUp } from './tablesPopUp/TablePopUp';
import { useMemo, useState } from 'react';
import LaunchIcon from '@mui/icons-material/Launch';
import { ROUTE_PATHS } from 'src/routes';
interface PopupPropsWxNfdr {
    attributes: any,
    setSelectedStation: any,
    setPopupPosition: any,
    popupPosition: any,
    elementList: any
}

const PopupWxNfdr: React.FC<PopupPropsWxNfdr> = ({ attributes, setSelectedStation, setPopupPosition, popupPosition, elementList }) => {
    const [state, dispatch] = useStoreContext();
    const selectChartTableType = useChartTableSelect(dispatch);
    const [stationMeta, setStationMeta] = useState<any>(null);

    const handleDragStop = (e: any, data: any) => {
        setPopupPosition({ x: data.x, y: data.y });
        localStorage.setItem('popup', JSON.stringify({ x: data.x, y: data.y }))

    };

    useMemo(()=>{
        const findValue = elementList.filter((item) => item.value === state.chartTable.value);
        if(findValue.length<1){
            selectChartTableType(state.selectedElement?.defaultChart);
        }
    },[state.chartTable.value, elementList, selectChartTableType, state.selectedElement?.defaultChart])

    const handleChartTableSelect = (e: any) => {
        const findValue = elementList.filter((item) => item.value === e.target.value);
        if (findValue.length >= 1) {
            selectChartTableType(findValue[0]);
        }
    };

      const goToChart = () =>{
        window.open(`${ROUTE_PATHS.table}/charts/${stationMeta.station_id}`,'_blank' )
      }

    return (
        <Draggable
            bounds="parent" 
            onStop={handleDragStop}
            defaultPosition={popupPosition}
        >
            <div
                style={{
                    backgroundColor: '#f6f6f6',
                    boxShadow: '0 .5rem 1rem 0 rgba(0,0,0,.1)',
                    color: 'black',
                    zIndex: 2001,
                    position: 'absolute',
                    cursor: 'grab',
                    maxHeight: '95vh',
                    maxWidth: '500px',
                    minWidth: '450px',
                    borderRadius: '5px',
                }}
            >
                <div style={{ position: 'absolute', right: 0, top: 0, zIndex: 800 }}>
                    <IconButton aria-label="close" onClick={() => setSelectedStation(null)}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <Grid row gap="md">
                    <Grid
                        desktop={{ col: 9 }}
                        className="display-flex flex-row flex-align-center flex-justify margin-bottom-2 padding-top-2">
                        <span
                            className="font-sans-md text-bold"
                            style={{ fontSize: '.9rem', paddingLeft: '1rem', textTransform: 'uppercase' }}
                        >
                            {attributes.name}, {attributes.network}, {attributes.state}, {attributes.id}
                        </span>
                    </Grid>
                </Grid>
                <div style={{ minHeight: '120px', maxWidth: '500px', maxHeight: '80vh', overflowY: 'auto' }} className="smooth-scrollbar">

                    <Accordion id="StationMetaData" className='accordion-style'>
                        <AccordionSummary
                            className='accordion-title-smaller'
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="StationMetaData"
                            id="StationMetaData"
                        >
                            Station MetaData
                        </AccordionSummary>
                        <AccordionDetails>
                            <StationMetaDataPopUp id={attributes.id} setStationMeta={setStationMeta}/>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion className='accordion-style'>
                        <AccordionSummary
                            className='accordion-title-smaller'
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="weatherChart"
                            id="weatherChart"
                        >
                            Expand to View Chart
                        </AccordionSummary>
                        {state.mapDataType==='FireDanger'? 
                            <Grid desktop={{ col: 4 }} style={{ padding: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'right', width: '100%' }}>
                                <Button disabled={(!stationMeta?.period_record_start || !stationMeta?.period_record_stop || !stationMeta?.has_historic_data) } onClick={goToChart} style={{ textTransform: 'capitalize'}}>Go to Charts <LaunchIcon fontSize='small' /></Button>
                            </Grid>
                            : ""
                        }
                        {
                            (state.mapDataType==='Weather'|| state.mapDataType==='FireDanger') && 
                            <AccordionDetails>
                                <label htmlFor='chartTableChange' id='chartTableChange'
                                    style={{ display: 'inline', fontWeight: 700, fontSize: 'medium', paddingRight: '.5rem', paddingLeft: '.5rem' }}
                                >{state.mapDataType==='Weather'? "ELEMENT": "NFDRS Outputs"}
                                    <Select
                                        labelId='chartTableChange'
                                        value={state.chartTable.value}
                                        id="chartTableChange"
                                        onChange={handleChartTableSelect}
                                        style={{ marginLeft: '.5rem', fontSize: '11px', width: '60%', zIndex: 2001 }}
                                        className="select-styles"
                                        inputProps={{
                                            id: 'chartTableChange',
                                        }}
                                        MenuProps={{
                                            style: { zIndex: 2001 }
                                        }}
                                    >
                                        {elementList.map((chartTable, index) => (
                                            <MenuItem value={chartTable.value} key={`${chartTable.value} ${index}`} style={{ zIndex: 2001 }}>
                                                {chartTable.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </label>
                                <div style={{ padding: '5px' }}>
                                    <ChartPopUpWXNfdrs id={attributes.id} stationMeta={stationMeta}/>
                                </div>
                            </AccordionDetails>
                        }
                    </Accordion>

                    <Accordion className='accordion-style' defaultExpanded>
                        <AccordionSummary
                            className='accordion-title-smaller'
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="hourlyTable"
                            id="hourlyTable"
                        >
                            Expand to View Observation Table
                        </AccordionSummary>
                        {
                            (state.mapDataType==='Weather'|| state.mapDataType==='FireDanger') && 
                            <AccordionDetails>
                                <div>
                                    <TablePopUp id={attributes.id} stationMeta={stationMeta}/>
                                </div>
                            </AccordionDetails>
                        }
                    </Accordion>
                </div>
            </div>
        </Draggable>

    )
}

export default PopupWxNfdr;